const configs = {
  API_DOMAIN: process.env.REACT_APP_API_DEV,
  MAP_BOX_API: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
};

export default configs;
